import { put, takeLatest } from 'redux-saga/effects';
import { taskCollection } from 'collections/tasks';
import { saveCompanyTasksSagaAction } from '../actions';
import { saveCompanyTasks } from '../slice';
function* saveCompanyTasksSaga({ payload }) {
    const tasks = payload || [];
    yield put(saveCompanyTasks(tasks === null || tasks === void 0 ? void 0 : tasks.map((t)=>t.taskId)));
    taskCollection.push(tasks, {
        source: 'fetch'
    });
}
export const watchSaveCompanyTasksSaga = function*() {
    yield takeLatest(saveCompanyTasksSagaAction.type, saveCompanyTasksSaga);
};
